import axios, { getAuthHeaders, getFormDataHeaders } from './config'

export default {
    store: function(documentType) {
        return axios.post('/document-types', documentType, {
            headers: getFormDataHeaders()
        })
    },

    all: function() {
        return axios.get('/document-types', {
            headers: getAuthHeaders()
        })
    },

    documentTypeMetadata: function(documentTypeId) {
        return axios.get(`/document-types/${documentTypeId}`, {
            headers: getAuthHeaders()
        })
    },

    delete: function(documentTypeId) {
        return axios.delete(`/document-types/${documentTypeId}`, {
            headers: getAuthHeaders()
        })
    },

    update: function(data) {
        return axios.post(`/document-types/${data.id}`, data.documentType, {
            headers: getAuthHeaders()
        })
    },
    countDocumentTypes: function() {
        return axios.get('/document-types/count', {
            headers: getAuthHeaders()
        })
    },
    getStat: function() {
        return axios.get('/count', {
            headers: getAuthHeaders()
        })
    },
}